import { decamelizeKeys } from 'humps';
import { stringify } from 'qs';

// eslint-disable-next-line import/prefer-default-export
export function paramsSerializer(params: object) {
  const decamelizedParams = decamelizeKeys(params);

  return stringify(decamelizedParams, { arrayFormat: 'brackets' });
}
